import React from "react";
import SprintBacklogTitleList from "./SprintBacklogTitleList";
import SortButton from "./SortButton";
import FilterButton from "./FilterButton";
import QuoteButton from "./QuoteButton";

function SprintBacklogSection({ selectedItems, onSort, onFilter, colourBlindMode }) {
    return (
        <div class="relative flex justify-between h-24 bg-[#9b9b9b] z-[1] mt-[70px] ">
            {/*  section Title */}
            <div class="text-white font-sans text-3xl ml-[385px] w-[40vw] items-center">
                <SprintBacklogTitleList selectedItems={selectedItems} colourBlindMode={colourBlindMode} />
            </div>
            <div class="flex items-center space-x-[3vh] mr-[40px] mt-[20px]">
                {/* pass the onsort function here */}
                <QuoteButton colourBlindMode={colourBlindMode}/>
                <SortButton onSort={onSort} colourBlindMode={colourBlindMode} />
                <FilterButton onFilter={onFilter} colourBlindMode={colourBlindMode}/>
            </div>
        </div>
    );
}

export default SprintBacklogSection;
